// extracted by mini-css-extract-plugin
module.exports = {"warning":"SidesheetWarning_warning__2vChM","warning__icon":"SidesheetWarning_warning__icon__P9_-u"};